"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var Link_1 = __importDefault(require("../Link/Link"));
var Typography_1 = require("../Typography/Typography");
var TabMenuItemContainer = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  white-space: nowrap;\n  margin: 0;\n"], ["\n  list-style: none;\n  white-space: nowrap;\n  margin: 0;\n"])));
var TabMenuItemLink = (0, styled_components_1.default)(Link_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  cursor: pointer;\n  line-height: 1.33;\n  padding: 0.4rem 0.4rem 1.6rem;\n  margin-right: ", ";\n  text-transform: uppercase;\n  position: relative;\n  z-index: 9;\n  outline-color: ", ";\n  position: relative;\n  border-bottom: ", ";\n  text-decoration: none;\n\n  ", "\n"], ["\n  display: block;\n  cursor: pointer;\n  line-height: 1.33;\n  padding: 0.4rem 0.4rem 1.6rem;\n  margin-right: ", ";\n  text-transform: uppercase;\n  position: relative;\n  z-index: 9;\n  outline-color: ", ";\n  position: relative;\n  border-bottom: ", ";\n  text-decoration: none;\n\n  ", "\n"])), function (_a) {
    var isLast = _a.isLast;
    return isLast ? '0' : '2.2rem';
}, b2c_theme_1.colors.primaryColor, function (_a) {
    var active = _a.active;
    return active ? "3px solid ".concat(b2c_theme_1.colors.primaryColor) : 'none';
}, function (_a) {
    var disabled = _a.disabled;
    if (disabled) {
        return "\n        background-color: ".concat(b2c_theme_1.colors.button.grey, ";\n        outline-color: ").concat(b2c_theme_1.colors.button.outline.dark, ";\n      ");
    }
});
var TabMenuItemButton = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: transparent;\n  border: none;\n  font-family: '", "';\n  color: ", ";\n  cursor: pointer;\n  font-size: 1.2rem;\n  line-height: 1.33;\n  padding: 0.4rem 0.4rem 1.6rem;\n  margin-right: ", ";\n  text-transform: uppercase;\n  position: relative;\n  z-index: 9;\n  outline-color: ", ";\n  position: relative;\n  border-bottom: ", ";\n\n  ", "\n\n  @media (max-width: 768px) {\n    padding: 0.2rem 0.2rem 1.2rem;\n  }\n"], ["\n  background-color: transparent;\n  border: none;\n  font-family: '", "';\n  color: ", ";\n  cursor: pointer;\n  font-size: 1.2rem;\n  line-height: 1.33;\n  padding: 0.4rem 0.4rem 1.6rem;\n  margin-right: ", ";\n  text-transform: uppercase;\n  position: relative;\n  z-index: 9;\n  outline-color: ", ";\n  position: relative;\n  border-bottom: ", ";\n\n  ", "\n\n  @media (max-width: 768px) {\n    padding: 0.2rem 0.2rem 1.2rem;\n  }\n"])), function () { return b2c_theme_1.fonts.defaultMedium; }, function (_a) {
    var active = _a.active;
    return active ? b2c_theme_1.colors.darkTitleFontColor : b2c_theme_1.colors.primaryLightFontColor;
}, function (_a) {
    var isLast = _a.isLast;
    return isLast ? '0' : '1.8rem';
}, function () { return "".concat(b2c_theme_1.colors.primaryColor); }, function (_a) {
    var active = _a.active;
    return active ? "3px solid ".concat(b2c_theme_1.colors.primaryColor) : 'none';
}, function (_a) {
    var disabled = _a.disabled;
    if (disabled) {
        return "\n        background-color: ".concat(b2c_theme_1.colors.button.grey, ";\n        color: ").concat(b2c_theme_1.colors.button.font.default, ";\n        outline-color: ").concat(b2c_theme_1.colors.button.outline.dark, ";\n      ");
    }
});
var TabMenuItem = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.isLast, isLast = _d === void 0 ? false : _d, onClick = _a.onClick, _e = _a.openInNewWindow, openInNewWindow = _e === void 0 ? false : _e, text = _a.text, url = _a.url, rest = __rest(_a, ["active", "disabled", "isLast", "onClick", "openInNewWindow", "text", "url"]);
    var onClickProxy = onClick
        ? function (event) {
            if (!disabled) {
                onClick(event);
            }
        }
        : undefined;
    return (react_1.default.createElement(TabMenuItemContainer, __assign({ active: active, "data-testid": "tab-menu-item-container", isLast: isLast }, rest), !url ? (react_1.default.createElement(TabMenuItemButton, { active: active, "data-testid": "tab-menu-item-button", disabled: disabled, isLast: isLast, onClick: onClickProxy, type: "button" }, text)) : (react_1.default.createElement(TabMenuItemLink, { active: active, "data-testid": "tab-menu-item-link", disabled: disabled, isLast: isLast, onClick: onClick, targetBlank: openInNewWindow, text: text, to: url, textAlign: "left", textTheme: disabled ? 'primary' : active ? 'darkTitle' : 'secondary', textVariant: Typography_1.TypeVariants.bodySmall, textComponent: Typography_1.TypeVariants.span }))));
};
exports.default = TabMenuItem;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TabMenuItem.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/TabMenuItem/TabMenuItem.js
// module id = 1501
// module chunks = 2 5 6 16 18 19